export const css = {
	root: '_1SMTTaew',
	linksWrapper: 'PWrK61FW',
	prev: '_1Atyp-7n',
	next: '_2ylXKc0M',
	icon: '_1oh9nJXT',
	label: 'e8M-6tci',
	link: '_3BUYvfXL',
	currentPage: 'apmvA1Dl',
	selectWrapper: 'lpUYtVjM',
	' _key': 'certwise-theme/dojo/pagination'
};

export default css;
